import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MultiTenantManagement = ({ gyms }) => {
  const getStatusColor = (status) => {
    const colors = {
      excellent: 'var(--color-success)',
      good: 'var(--color-info)',
      warning: 'var(--color-warning)',
      critical: 'var(--color-error)'
    };
    return colors?.[status] || 'var(--color-muted)';
  };

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Building2" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-xl font-heading font-semibold text-foreground">Multi-Tenant Management</h3>
          <p className="text-sm text-muted-foreground">Quick access to gym locations</p>
        </div>
      </div>
      <div className="space-y-3 max-h-96 overflow-y-auto custom-scrollbar">
        {gyms?.map((gym) => (
          <div
            key={gym?.id}
            className="bg-muted/50 rounded-lg p-4 hover:bg-muted transition-colors cursor-pointer"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="font-semibold text-foreground">{gym?.name}</h4>
                  <div
                    className="w-2 h-2 rounded-full"
                    style={{ backgroundColor: getStatusColor(gym?.status) }}
                  />
                </div>
                <p className="text-xs text-muted-foreground">{gym?.members} active members</p>
              </div>
              <Button variant="ghost" size="sm">
                <Icon name="ExternalLink" size={14} />
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-3">
              <div>
                <p className="text-xs text-muted-foreground mb-1">Revenue</p>
                <p className="text-sm font-semibold text-foreground">${(gym?.revenue / 1000)?.toFixed(0)}K</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Profit</p>
                <p className="text-sm font-semibold text-success">${(gym?.profit / 1000)?.toFixed(0)}K</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Margin</p>
                <p className="text-sm font-semibold text-foreground">{gym?.margin}%</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <Button variant="outline" className="w-full">
          <Icon name="Plus" size={16} className="mr-2" />
          Add New Gym Location
        </Button>
      </div>
    </div>
  );
};

export default MultiTenantManagement;